import React from 'react';
import Layout from '../components/Layout';
import InteractiveDemo from '../components/InteractiveDemo';

const DemoPage: React.FC = () => {
  return (
    <Layout>
      <InteractiveDemo />
    </Layout>
  );
};

export default DemoPage;


